/*
 * Kleine Datums-Helper als Ersatz für moment.
 */
const rtfCache = {}

function getRtf(locale) {
    if (!rtfCache[locale]) {
        rtfCache[locale] = new Intl.RelativeTimeFormat(locale, { numeric: "auto" })
    }
    return rtfCache[locale]
}

/**
 * "vor 3 Tagen" / "in 2 Stunden" - ohne führendes "vor" (wie moment.fromNow(true)).
 * Gibt z.B. "3 Tagen" zurück.
 */
export function timeAgoWithoutPrefix(dateInput, locale = "de") {
    const date = new Date(dateInput)
    if (isNaN(date.getTime())) return ""
    const diffSeconds = Math.round((date.getTime() - Date.now()) / 1000)
    const abs = Math.abs(diffSeconds)
    const rtf = getRtf(locale)

    const steps = [
        { limit: 60, unit: "second" },
        { limit: 3600, unit: "minute" },
        { limit: 86400, unit: "hour" },
        { limit: 86400 * 30, unit: "day" },
        { limit: 86400 * 365, unit: "month" },
        { limit: Infinity, unit: "year" }
    ]
    const unit = steps.find((s) => abs < s.limit).unit
    const divisor = { second: 1, minute: 60, hour: 3600, day: 86400, month: 86400 * 30, year: 86400 * 365 }[unit]
    const value = Math.round(diffSeconds / divisor)

    return rtf.format(value, unit).replace(/^\w+\s/, "")
}

/**
 * Moment-Format-Ersätze für die im Projekt genutzten Formate.
 */
export function formatDayMonth(dateInput) {
    const date = new Date(dateInput)
    if (isNaN(date.getTime())) return ""
    return date.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit" }) + "."
}

export function formatLongDateTime(dateInput, locale = "de") {
    const date = new Date(dateInput)
    if (isNaN(date.getTime())) return ""
    return date.toLocaleDateString(locale, { year: "numeric", month: "long", day: "numeric" }) + ", " + date.toLocaleTimeString(locale, { hour: "2-digit", minute: "2-digit" })
}